import React, { useEffect } from 'react'

export default function useTitle(title) {
  useEffect(() => {
    document.title = title + ' - BMS'
    return () => {
      document.title = 'BMS - MMEA GROUP'
    }
  }, [title])
}
